(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    if (cartDrawer.dataset.twCartDrawerInitialized === '1') return;
    cartDrawer.dataset.twCartDrawerInitialized = '1';
    const cartDrawerController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const cartDrawerSignal = cartDrawerController ? cartDrawerController.signal : null;

    function on(target, eventName, handler, options) {
      if (!target) return;
      const listenerOptions = options ? Object.assign({}, options) : {};
      if (cartDrawerSignal) listenerOptions.signal = cartDrawerSignal;
      target.addEventListener(eventName, handler, listenerOptions);
    }

    function destroyCartDrawer() {
      if (cartDrawerController) cartDrawerController.abort();
      delete cartDrawer.dataset.twCartDrawerInitialized;
      unlockCartScroll();
    }
    
    const stringsEl = document.querySelector('script[data-cart-drawer-strings]');
    const strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    
    const openButtons = document.querySelectorAll('[data-cart-drawer-open]');
    const closeButtons = document.querySelectorAll('[data-cart-drawer-close]');

    function isMobileViewport() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    }
    let lastFocusedBeforeCart = null;
    let previousBodyOverflow = '';
    let cartScrollLocked = false;

    function lockCartScroll() {
      if (!cartScrollLocked) {
        previousBodyOverflow = document.body.style.overflow || '';
        cartScrollLocked = true;
      }
      document.body.style.overflow = 'hidden';
    }

    function unlockCartScroll() {
      if (cartScrollLocked) {
        document.body.style.overflow = previousBodyOverflow;
        cartScrollLocked = false;
      }
    }
    
    function openDrawer(options) {
      options = options || {};
      lastFocusedBeforeCart = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      cartDrawer.setAttribute('aria-hidden', 'false');
      lockCartScroll();
      // Desktop: only open upsell panel right after an add-to-cart.
      // Mobile uses inline upsell and never opens the lateral panel.
      var shouldOpenUpsell = !!options.fromAdd && !isMobileViewport();
      updateCart({ openUpsellPanel: shouldOpenUpsell });
      requestAnimationFrame(function() {
        var focusTarget = cartDrawer.querySelector('[data-cart-drawer-close], button, a, input, textarea, select');
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      });
    }
    
    function closeDrawer(options) {
      options = options || {};
      cartDrawer.classList.remove('cart-drawer--upsell-open');
      var panel = cartDrawer.querySelector('[data-cart-upsell-panel]');
      if (panel) panel.classList.remove('cart-drawer__upsell-panel--open');
      cartDrawer.querySelectorAll('.cart-drawer__addon-content--open').forEach(function(p) { p.classList.remove('cart-drawer__addon-content--open'); });
      cartDrawer.querySelectorAll('.cart-drawer__addon-btn.is-open').forEach(function(b) { b.classList.remove('is-open'); });
      cartDrawer.setAttribute('aria-hidden', 'true');
      unlockCartScroll();
      if (options.restoreFocus !== false && lastFocusedBeforeCart && typeof lastFocusedBeforeCart.focus === 'function') {
        lastFocusedBeforeCart.focus({ preventScroll: true });
      }
    }
    
    on(cartDrawer, 'click', function(e) {
      var openBtn = e.target.closest('[data-addon-open]');
      var closeBtn = e.target.closest('[data-addon-close]');
      if (openBtn) {
        e.preventDefault();
        var id = openBtn.getAttribute('data-addon-open');
        var panel = cartDrawer.querySelector('#cart-drawer-addon-' + id);
        if (!panel) return;
        var wasOpen = panel.classList.contains('cart-drawer__addon-content--open');
        cartDrawer.querySelectorAll('.cart-drawer__addon-content').forEach(function(p) { p.classList.remove('cart-drawer__addon-content--open'); p.setAttribute('aria-hidden', 'true'); });
        cartDrawer.querySelectorAll('.cart-drawer__addon-btn').forEach(function(b) { b.classList.remove('is-open'); });
        if (!wasOpen) {
          panel.classList.add('cart-drawer__addon-content--open');
          panel.setAttribute('aria-hidden', 'false');
          openBtn.classList.add('is-open');
        }
        return;
      }
      if (closeBtn) {
        e.preventDefault();
        var id = closeBtn.getAttribute('data-addon-close');
        var panel = cartDrawer.querySelector('#cart-drawer-addon-' + id);
        var btn = cartDrawer.querySelector('[data-addon-open="' + id + '"]');
        if (panel) panel.classList.remove('cart-drawer__addon-content--open');
        if (panel) panel.setAttribute('aria-hidden', 'true');
        if (btn) btn.classList.remove('is-open');
        return;
      }
    });
    
    openButtons.forEach(btn => {
      on(btn, 'click', function () { openDrawer({ fromAdd: false }); });
    });
    
    closeButtons.forEach(btn => {
      on(btn, 'click', closeDrawer);
    });

    on(document, 'keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });

    on(document, 'shopify:section:unload', function(e) {
      if (!e.target || e.target.contains(cartDrawer) || cartDrawer.contains(e.target)) {
        closeDrawer({ restoreFocus: false });
        destroyCartDrawer();
      }
    });
    
    function formatMoney(cents, currency = 'USD') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeAttr(value) {
      return escapeHtml(value);
    }

    function safeUrl(value) {
      const raw = String(value == null ? '' : value).trim();
      if (!raw || /^(javascript|data):/i.test(raw)) return '';
      return escapeAttr(raw);
    }

    function updateShippingBar(cartTotal, currency) {
      if (!strings.free_shipping_enabled) return;
      const bar = cartDrawer.querySelector('[data-cart-shipping-bar]');
      if (!bar) return;

      const minimum = parseInt(strings.free_shipping_minimum) || 0;
      if (minimum <= 0) return;

      const msg = bar.querySelector('[data-cart-shipping-msg]');
      const progress = bar.querySelector('[data-cart-shipping-progress]');
      const remaining = Math.max(0, minimum - cartTotal);
      const percent = Math.min(100, (cartTotal / minimum) * 100);
      const achieved = cartTotal >= minimum;

      progress.style.width = percent + '%';
      progress.classList.toggle('cart-drawer__shipping-progress--done', achieved);

      if (achieved) {
        msg.innerHTML = strings.free_shipping_achieved_html;
      } else {
        const remainingFormatted = formatMoney(remaining, currency);
        msg.innerHTML = strings.free_shipping_spend_html.replace('__AMOUNT__', remainingFormatted);
      }
    }

    function renderCartItem(item, currency) {
      const itemKey = escapeAttr(item.key || '');
      const itemUrl = safeUrl(item.url) || '#';
      const productTitle = escapeHtml(item.product_title || '');
      const itemTitle = escapeHtml(item.title || item.product_title || '');
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' 
        ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` 
        : '';
      const removeLabel = (strings.remove_item || 'Quitar') + ' ' + (item.product_title || '');
      const discounts = (item.discounts || []).length > 0
        ? `<ul class="cart-item__discounts" aria-label="Discounts">${item.discounts.map(d => `<li class="cart-item__discount-item">${escapeHtml(d.title || d.code || '')} (-${formatMoney(d.amount || 0, currency)})</li>`).join('')}</ul>`
        : '';
      
      let imageUrl = '';
      if (item.image) {
        imageUrl = typeof item.image === 'string' ? item.image : item.image;
      }
      
      return `
        <div class="cart-item" data-cart-item data-key="${itemKey}">
          <div class="cart-item__image">
            ${safeUrl(imageUrl) ? `
              <a href="${itemUrl}">
                <img src="${safeUrl(imageUrl)}" alt="${escapeAttr(item.title || item.product_title || '')}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">
              </a>
            ` : ''}
          </div>
          
          <div class="cart-item__details">
            <a href="${itemUrl}" class="cart-item__title">${productTitle || itemTitle}</a>
            ${variantTitle}
            <div class="cart-item__price">${formatMoney(item.final_line_price, currency)}</div>
            ${discounts}
          </div>
          
          <div class="cart-item__actions">
            <div class="cart-item__quantity">
              <button type="button" class="cart-item__qty-btn" data-cart-update data-key="${itemKey}" data-qty="${item.quantity - 1}">-</button>
              <span class="cart-item__qty-value" data-cart-qty>${item.quantity}</span>
              <button type="button" class="cart-item__qty-btn" data-cart-update data-key="${itemKey}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <p class="cart-item__error" data-cart-item-error hidden></p>
            <button type="button" class="cart-item__remove" data-cart-remove data-key="${itemKey}" aria-label="${escapeAttr(removeLabel)}">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="m19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        </div>
      `;
    }

    function renderDiscountCodeLi(discount, currency, removeLabel) {
      const title = discount.title || discount.code || '';
      const amount = discount.total_allocated_amount != null ? discount.total_allocated_amount : (discount.amount || 0);
      return `<li class="cart-drawer__discount-code" data-discount-code="${escapeAttr(title)}">
        <span>${escapeHtml(title)}</span>
        <span class="cart-drawer__discount-amount">-${formatMoney(amount, currency)}</span>
        <button type="button" class="cart-drawer__discount-remove" data-cart-discount-remove aria-label="${escapeAttr(removeLabel + ' ' + title)}">${escapeHtml(strings.discount_remove || 'Remove')}</button>
      </li>`;
    }

    function loadUpsellRecommendations(autoEl) {
      if (!autoEl) return Promise.resolve();
      var url = autoEl.getAttribute('data-upsell-auto-url');
      if (!url) return Promise.resolve();
      autoEl.dataset.fetched = '1';
      return fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var track = doc.querySelector('[data-upsell-track]');
          var wrap = doc.querySelector('.cart-upsell-wrap');
          if (track && track.innerHTML.trim()) {
            autoEl.innerHTML = track.innerHTML;
            autoEl.classList.remove('cart-drawer__upsell-list--auto');
          } else if (wrap) {
            autoEl.innerHTML = wrap.innerHTML;
            autoEl.classList.remove('cart-drawer__upsell-list--auto');
          }
        })
        .catch(function() {});
    }

    function refreshUpsellFromCart(cart, options) {
      options = options || {};
      var panelAutoEl = cartDrawer.querySelector('[data-cart-upsell-panel] [data-upsell-auto-url]');
      var inlineAutoEl = cartDrawer.querySelector('[data-cart-upsell-inline] [data-upsell-auto-url]');
      if ((!panelAutoEl && !inlineAutoEl) || !cart || cart.item_count < 1 || !cart.items || cart.items.length < 1) return;

      var srcEl = panelAutoEl || inlineAutoEl;
      var root = srcEl.getAttribute('data-upsell-rec-root');
      var sectionId = srcEl.getAttribute('data-upsell-rec-section') || 'tw-cart-upsell';
      var limit = srcEl.getAttribute('data-upsell-rec-limit') || '6';
      var lastItem = cart.items[cart.items.length - 1];
      var productId = lastItem && lastItem.product_id;
      if (!productId) return;
      if (!root) {
        var existing = srcEl.getAttribute('data-upsell-auto-url') || '';
        var q = existing.indexOf('?');
        root = q > -1 ? existing.substring(0, q) : '/recommendations/products';
      }
      var url = root + '?product_id=' + productId + '&limit=' + encodeURIComponent(limit) + '&section_id=' + encodeURIComponent(sectionId);
      [panelAutoEl, inlineAutoEl].forEach(function(el) {
        if (!el) return;
        el.setAttribute('data-upsell-auto-url', url);
        delete el.dataset.fetched;
        var loadingText = el.getAttribute('data-upsell-loading-text') || '';
        el.innerHTML = '<span class="cart-drawer__upsell-loading">' + loadingText + '</span>';
        el.classList.add('cart-drawer__upsell-list--auto');
      });

      if (options.openPanel && !isMobileViewport()) {
        openUpsellPanel(true);
      }

      // Mobile: load inline recommendations without opening a lateral panel.
      if (isMobileViewport() && inlineAutoEl) {
        var shouldFetch = url && !inlineAutoEl.dataset.fetched;
        if (shouldFetch) {
          loadUpsellRecommendations(inlineAutoEl);
        }
      }
    }

    function updateCart(options) {
      options = options || {};
      return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(el => {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.style.display = 'flex';
            } else {
              el.style.display = 'none';
            }
          });
          
          const itemsContainer = cartDrawer.querySelector('[data-cart-items]');
          const addonsBlock = cartDrawer.querySelector('[data-cart-addons]');
          const footer = cartDrawer.querySelector('.cart-drawer__footer');
          const container = cartDrawer.querySelector('.cart-drawer__container');
          const upsellTrigger = cartDrawer.querySelector('[data-cart-upsell-trigger]');
          const upsellPanelEl2 = cartDrawer.querySelector('[data-cart-upsell-panel]');
          const upsellInline = cartDrawer.querySelector('[data-cart-upsell-inline]');
          
          updateShippingBar(cart.items_subtotal_price, cart.currency);

          if (cart.item_count > 0) {
            if (upsellTrigger) upsellTrigger.hidden = false;
            if (upsellPanelEl2) upsellPanelEl2.hidden = false;
            if (upsellInline) upsellInline.hidden = false;
            itemsContainer.innerHTML = cart.items.map(item => renderCartItem(item, cart.currency)).join('');
            
            const discountRemoveLabel = strings.discount_remove || 'Remove';
            const apps = cart.cart_level_discount_applications || [];
            const footerDiscountsHtml = apps.length > 0
              ? `<ul class="cart-drawer__footer-discounts" data-cart-footer-discounts">${apps.map(d => `<li><span>${escapeHtml(d.title || '')}</span> <span>-${formatMoney(d.total_allocated_amount != null ? d.total_allocated_amount : 0, cart.currency)}</span></li>`).join('')}</ul>`
              : '';
            
            if (!footer) {
              let addonsHtml = '';
              if (strings.show_note || strings.show_discount) {
                var cancelStr = escapeHtml(strings.cancel || 'Cancel');
                addonsHtml = '<div class="cart-drawer__addons-wrap" data-cart-addons><div class="cart-drawer__addon-buttons">';
                if (strings.show_note) {
                  addonsHtml += `<button type="button" class="cart-drawer__addon-btn" data-addon-open="note" aria-label="${escapeAttr(strings.note_title || 'Order note')}"><svg width="18" height="18" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10.8642 1.18519V0.691358C10.8642 0.296296 10.5679 0 10.1728 0C9.77778 0 9.48148 0.395062 9.48148 0.691358V1.08642H5.03704V0.691358C5.03704 0.395062 4.74074 0 4.34568 0C3.95062 0 3.65432 0.395062 3.65432 0.691358V1.18519C1.28395 1.38272 0 2.96296 0 5.4321V11.6543C0 14.4198 1.58025 16 4.34568 16H10.1728C12.9383 16 14.5185 14.4198 14.5185 11.6543V5.4321C14.5185 2.96296 13.2346 1.38272 10.8642 1.18519ZM4.34568 3.55556C4.64198 3.55556 5.03704 3.25926 5.03704 2.8642V2.46914H9.48148V2.8642C9.48148 3.25926 9.87654 3.55556 10.1728 3.55556C10.4691 3.55556 10.8642 3.25926 10.8642 2.8642V2.46914C12.4444 2.66667 13.1358 3.65432 13.1358 5.4321V11.6543C13.1358 13.7284 12.1481 14.6173 10.1728 14.6173H4.34568C2.27161 14.6173 1.38272 13.6296 1.38272 11.6543V5.33333C1.38272 3.55556 2.07407 2.5679 3.65432 2.37037V2.76543C3.65432 3.25926 3.95062 3.55556 4.34568 3.55556Z" fill="currentColor"/><path d="M4.34565 8.00019H10.1728C10.4691 8.00019 10.8642 7.7039 10.8642 7.30884C10.8642 6.91377 10.4691 6.61748 10.1728 6.61748H4.34565C3.95059 6.61748 3.6543 6.91377 3.6543 7.30884C3.6543 7.7039 4.04936 8.00019 4.34565 8.00019Z" fill="currentColor"/><path d="M7.30862 10.2715H4.34565C3.95059 10.2715 3.6543 10.5678 3.6543 10.9629C3.6543 11.3579 4.04936 11.6542 4.34565 11.6542H7.30862C7.60491 11.6542 7.99998 11.3579 7.99998 10.9629C7.99998 10.5678 7.60491 10.2715 7.30862 10.2715Z" fill="currentColor"/></svg><span class="cart-drawer__addon-btn-label">${escapeHtml(strings.note_title || 'Order note')}</span></button>`;
                }
                if (strings.show_discount) {
                  addonsHtml += `<button type="button" class="cart-drawer__addon-btn" data-addon-open="discount" aria-label="${escapeAttr(strings.coupon_title || 'Discount code')}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7a2 2 0 0 1 2-2h10l6 6v6a2 2 0 0 1-2 2H9l-6-6V7Z"></path><path d="M7.5 8.5h.01"></path><path d="m10 14 4-4"></path></svg><span class="cart-drawer__addon-btn-label">${escapeHtml(strings.coupon_title || 'Discount code')}</span></button>`;
                }
                addonsHtml += '</div></div>';
                if (strings.show_note) {
                  addonsHtml += `<div class="cart-drawer__addon-content" id="cart-drawer-addon-note" data-addon-panel="note" aria-hidden="true"><div class="cart-drawer__addon-content-inner"><p class="cart-drawer__addon-content-title">${escapeHtml(strings.note_title || 'Order note')}</p><textarea id="cart-drawer-note" class="cart-drawer__textarea" data-cart-note placeholder="${escapeAttr(strings.note_placeholder || '')}" rows="3">${escapeHtml(cart.note || '')}</textarea><button type="button" class="cart-drawer__addon-close" data-addon-close="note">${cancelStr}</button></div></div>`;
                }
                if (strings.show_discount) {
                  var couponTitleTxt = escapeHtml(strings.coupon_title || 'Discount code');
                  var couponEnterTxt = escapeAttr(strings.coupon_enter || '');
                  var couponApplyTxt = escapeHtml(strings.coupon_apply || 'Apply');
                  var listItemsTxt = apps.map(d => renderDiscountCodeLi(d, cart.currency, discountRemoveLabel)).join('');
                  addonsHtml += `<div class="cart-drawer__addon-content" id="cart-drawer-addon-discount" data-addon-panel="discount" aria-hidden="true"><div class="cart-drawer__addon-content-inner"><p class="cart-drawer__addon-content-title">${couponTitleTxt}</p><div class="cart-drawer__coupon-inline" data-cart-drawer-coupon-inline><label class="cart-drawer__coupon-label" for="cart-drawer-discount-inline">${couponTitleTxt}</label><div class="cart-drawer__coupon-row"><input type="text" id="cart-drawer-discount-inline" class="cart-drawer__input" data-cart-discount-input placeholder="${couponEnterTxt}" aria-label="${couponEnterTxt}" autocomplete="off"><button type="button" class="cart-drawer__discount-apply cart-drawer__coupon-apply-inline" data-cart-discount-apply>${couponApplyTxt}</button></div>${apps.length > 0 ? `<ul class="cart-drawer__discounts-inline-list" data-cart-discounts-list aria-label="${couponTitleTxt}">${listItemsTxt}</ul>` : ''}<p class="cart-drawer__discount-msg cart-drawer__discount-msg--error" data-cart-discount-error hidden></p><p class="cart-drawer__discount-msg cart-drawer__discount-msg--success" data-cart-discount-success hidden></p></div><button type="button" class="cart-drawer__addon-close" data-addon-close="discount">${cancelStr}</button></div></div>`;
                }
              }
              const cartUrl = safeUrl(cart.cart_url || '/cart') || '/cart';
              const viewCartBtnHtml = strings.show_view_cart_button !== false ? `<a href="${cartUrl}" class="cart-drawer__checkout-btn">${escapeHtml(strings.view_cart || 'View cart')}</a>` : '';
              const footerHTML = (addonsHtml || '') + `<div class="cart-drawer__footer"><div class="cart-drawer__totals" data-cart-totals>${footerDiscountsHtml}<div class="cart-drawer__total"><span class="cart-drawer__total-label">${escapeHtml(strings.subtotal || 'Subtotal')}</span><span class="cart-drawer__total-price" data-cart-total>${formatMoney(cart.total_price, cart.currency)}</span></div></div>${viewCartBtnHtml}<form action="${cartUrl}" method="post"><button type="submit" name="checkout" class="cart-drawer__checkout-btn cart-drawer__checkout-btn--primary">${escapeHtml(strings.checkout || 'Checkout')}</button></form></div>`;
              container.insertAdjacentHTML('beforeend', footerHTML);
              bindNoteAndDiscount();
            } else {
              const noteEl = cartDrawer.querySelector('[data-cart-note]');
              if (noteEl) noteEl.value = cart.note || '';
              const listEl = cartDrawer.querySelector('[data-cart-discounts-list]');
              if (listEl) listEl.innerHTML = apps.map(d => renderDiscountCodeLi(d, cart.currency, discountRemoveLabel)).join('');
              const footerDiscounts = cartDrawer.querySelector('[data-cart-footer-discounts]');
              if (footerDiscounts) {
                if (apps.length > 0) {
                  footerDiscounts.innerHTML = apps.map(d => `<li><span>${escapeHtml(d.title || '')}</span> <span>-${formatMoney(d.total_allocated_amount != null ? d.total_allocated_amount : 0, cart.currency)}</span></li>`).join('');
                  footerDiscounts.hidden = false;
                } else {
                  footerDiscounts.innerHTML = '';
                  footerDiscounts.hidden = true;
                }
              }
              const totalEl = cartDrawer.querySelector('[data-cart-total]');
              if (totalEl) totalEl.textContent = formatMoney(cart.total_price, cart.currency);
            }
          } else {
            itemsContainer.innerHTML = `
              <div class="cart-drawer__empty">
                <p>${escapeHtml(strings.empty || 'Your cart is empty')}</p>
                <a href="/collections/all" class="cart-drawer__empty-btn">${escapeHtml(strings.continue_shopping || 'Continue shopping')}</a>
              </div>
            `;
            if (addonsBlock) addonsBlock.remove();
            if (footer) footer.remove();
            cartDrawer.classList.remove('cart-drawer--upsell-open');
            var upsellPanel = cartDrawer.querySelector('[data-cart-upsell-panel]');
            if (upsellPanel) upsellPanel.classList.remove('cart-drawer__upsell-panel--open');
            if (upsellTrigger) upsellTrigger.hidden = true;
            if (upsellPanelEl2) upsellPanelEl2.hidden = true;
            if (upsellInline) upsellInline.hidden = true;
          }

          if (cart.item_count > 0) {
            var upsellPanelEl = cartDrawer.querySelector('[data-cart-upsell-panel]');
            var upsellAlreadyOpen =
              upsellPanelEl && upsellPanelEl.classList.contains('cart-drawer__upsell-panel--open');
            var openUpsellPanel =
              !!options.openUpsellPanel || upsellAlreadyOpen;
            refreshUpsellFromCart(cart, { openPanel: openUpsellPanel });
          }

          return cart;
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          throw error;
        });
    }

    let noteTimeout;
    function bindNoteAndDiscount() {
      const noteEl = cartDrawer.querySelector('[data-cart-note]');
      if (noteEl && !noteEl.dataset.bound) {
        noteEl.dataset.bound = '1';
        on(noteEl, 'input', function() {
          clearTimeout(noteTimeout);
          noteTimeout = setTimeout(function() {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteEl.value })
            }).then(() => {}).catch(err => console.error('Note update failed', err));
          }, 600);
        });
      }
      const applyBtn = cartDrawer.querySelector('[data-cart-discount-apply]');
      const discountInput = cartDrawer.querySelector('[data-cart-discount-input]');
      const errEl = cartDrawer.querySelector('[data-cart-discount-error]');
      const okEl = cartDrawer.querySelector('[data-cart-discount-success]');
      if (applyBtn && discountInput && !applyBtn.dataset.bound) {
        applyBtn.dataset.bound = '1';
        on(applyBtn, 'click', function() {
          const code = (discountInput.value || '').trim();
          if (errEl) errEl.hidden = true;
          if (okEl) okEl.hidden = true;

          if (!code) {
            if (errEl) {
              errEl.textContent = strings.coupon_enter || strings.discount_error || 'Enter a discount code';
              errEl.hidden = false;
            }
            return;
          }

          applyBtn.disabled = true;
          applyBtn.classList.add('is-loading');
          applyBtn.setAttribute('aria-busy', 'true');
          if (okEl) {
            okEl.textContent = 'Aplicando descuento…';
            okEl.hidden = false;
          }

          // Shopify-supported discount apply flow: /discount/CODE?redirect=/cart
          // Avoid using /cart/update.js with { discount } (not reliably supported).
          const redirectPath = '{{ routes.cart_url }}' || '/cart';
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath);
        });
      }
      cartDrawer.querySelectorAll('[data-cart-discount-remove]').forEach(btn => {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        on(btn, 'click', function() {
          // There isn't a reliable Shopify AJAX "remove discount" cart endpoint.
          // Keep behavior safe: go to cart page where customer can proceed/adjust checkout discounts.
          const redirectPath = '{{ routes.cart_url }}' || '/cart';
          window.location.href = redirectPath;
        });
      });
    }
    
    function updateCartTotal() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const totalElement = cartDrawer.querySelector('[data-cart-total]');
          if (totalElement) {
            totalElement.textContent = formatMoney(cart.total_price, cart.currency);
          }
          
          // Update cart count
          const cartCountElements = document.querySelectorAll('[data-cart-count]');
          cartCountElements.forEach(el => {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.style.display = 'flex';
            } else {
              el.style.display = 'none';
            }
          });
        })
        .catch(error => console.error('Error updating cart:', error));
    }
    
    // Upsell subdrawer open/close (panel to the left of cart)
    function openUpsellPanel(forceRefetch) {
      const panel = cartDrawer.querySelector('[data-cart-upsell-panel]');
      const trigger = cartDrawer.querySelector('[data-upsell-open]');
      const inlineTrack = cartDrawer.querySelector('[data-cart-upsell-inline] [data-upsell-auto-url]');

      if (isMobileViewport()) {
        // Mobile: do NOT open lateral panel. Load inline recommendations instead.
        if (inlineTrack) {
          var url = inlineTrack.getAttribute('data-upsell-auto-url');
          var shouldFetch = url && (forceRefetch || !inlineTrack.dataset.fetched);
          if (forceRefetch) {
            delete inlineTrack.dataset.fetched;
            var loadingText = inlineTrack.getAttribute('data-upsell-loading-text') || '';
            inlineTrack.innerHTML = '<span class="cart-drawer__upsell-loading">' + loadingText + '</span>';
            inlineTrack.classList.add('cart-drawer__upsell-list--auto');
          }
          if (shouldFetch) {
            loadUpsellRecommendations(inlineTrack);
          }
          // Keep UX simple: section is already inline inside drawer; no jump needed.
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        return;
      }

      if (panel) {
        cartDrawer.classList.add('cart-drawer--upsell-open');
        panel.classList.add('cart-drawer__upsell-panel--open');
        panel.setAttribute('aria-hidden', 'false');
        var autoEl = panel.querySelector('[data-upsell-auto-url]');
        if (autoEl) {
          var url = autoEl.getAttribute('data-upsell-auto-url');
          var shouldFetch = url && (forceRefetch || !autoEl.dataset.fetched);
          if (forceRefetch) {
            delete autoEl.dataset.fetched;
            var loadingText = autoEl.getAttribute('data-upsell-loading-text') || '';
            autoEl.innerHTML = '<span class="cart-drawer__upsell-loading">' + loadingText + '</span>';
            autoEl.classList.add('cart-drawer__upsell-list--auto');
          }
          if (shouldFetch) {
            loadUpsellRecommendations(autoEl);
          }
        }
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function closeUpsellPanel() {
      const panel = cartDrawer.querySelector('[data-cart-upsell-panel]');
      const trigger = cartDrawer.querySelector('[data-upsell-open]');
      if (isMobileViewport()) {
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      cartDrawer.classList.remove('cart-drawer--upsell-open');
      if (panel) {
        panel.classList.remove('cart-drawer__upsell-panel--open');
        panel.setAttribute('aria-hidden', 'true');
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function handleUpsellClick(e) {
      if (e.target.closest('[data-upsell-open]') && cartDrawer.contains(e.target.closest('[data-upsell-open]'))) {
        e.preventDefault();
        e.stopPropagation();
        // Mobile: force refetch so the inline track reliably populates on tap.
        openUpsellPanel(isMobileViewport());
        return true;
      }
      if (e.target.closest('[data-upsell-close]')) {
        e.preventDefault();
        closeUpsellPanel();
        return true;
      }
      var upsellAdd = e.target.closest('[data-upsell-add]');
      if (upsellAdd) {
        e.preventDefault();
        var variantId = upsellAdd.getAttribute('data-upsell-add');
        if (!variantId) return;
        upsellAdd.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).then(function(r) { return r.json(); }).then(function() {
          updateCart();
          openDrawer({ fromAdd: true });
        }).catch(function(err) {
          console.error('Error adding to cart:', err);
          alert('Error adding product to cart');
        }).finally(function() { upsellAdd.disabled = false; });
        return true;
      }
      return false;
    }
    on(cartDrawer, 'click', function(e) {
      handleUpsellClick(e);
    });
    on(document, 'click', function(e) {
      if (cartDrawer.getAttribute('aria-hidden') === 'false' && e.target.closest('#cart-drawer [data-upsell-open]')) {
        e.preventDefault();
        e.stopPropagation();
        openUpsellPanel();
      }
    }, { capture: true });
    
    // Handle cart updates
    on(cartDrawer, 'click', function(e) {
      const updateBtn = e.target.closest('[data-cart-update]');
      const removeBtn = e.target.closest('[data-cart-remove]');
      
      if (updateBtn) {
        e.preventDefault();
        var errorEl = updateBtn.closest('[data-cart-item]')?.querySelector('[data-cart-item-error]') || null;
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        const key = updateBtn.dataset.key;
        const qty = parseInt(updateBtn.dataset.qty);
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(function (res) {
          return res.json().then(function (data) { return { res: res, data: data }; });
        })
        .then(function (payload) {
          if (!payload.res.ok) {
            var msg = (payload.data && (payload.data.description || payload.data.message)) || 'No hay stock suficiente para aumentar la cantidad.';
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
            return;
          }
          updateCart();
        })
        .catch(function (error) {
          console.error('Error updating item:', error);
          if (errorEl) { errorEl.textContent = 'Error al actualizar el carrito. Intenta de nuevo.'; errorEl.hidden = false; }
        });
      }
      
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.dataset.key;
        
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
        .then(() => {
          // Update entire cart to reflect changes
          updateCart();
        })
        .catch(error => console.error('Error removing item:', error));
      }
    });
    
    function getAddButtonsForForm(form) {
      const buttons = [];
      const main = form.querySelector('button[type="submit"][name="add"]');
      if (main) buttons.push(main);
      /* form.id es el input name="id" (variante), no el atributo id del <form> — evita form.id.match is not a function */
      const formIdAttr = typeof form.getAttribute === 'function' ? form.getAttribute('id') : '';
      const m = formIdAttr && formIdAttr.match(/^product-form-(.+)$/);
      if (m) {
        const sticky = document.getElementById('tw-sticky-bar-add-' + m[1]);
        if (sticky) buttons.push(sticky);
      }
      return buttons;
    }

    function setAddButtonsLoading(buttons, loading) {
      const busyLabel = (strings.adding_to_cart || 'Loading').replace(/</g, '&lt;');
      buttons.forEach(function(btn) {
        if (!btn) return;
        if (loading) {
          if (btn.dataset.cartAddHtml == null) {
            btn.dataset.cartAddHtml = btn.innerHTML;
            btn.dataset.cartAddWasDisabled = btn.disabled ? '1' : '';
            btn.dataset.cartAddAriaLabel = btn.getAttribute('aria-label') || '';
          }
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.setAttribute('aria-label', busyLabel);
          btn.classList.add('tw-cart-add-btn--loading');
          btn.innerHTML = '<span class="tw-cart-add-btn__spinner" aria-hidden="true"></span>';
        } else {
          btn.removeAttribute('aria-busy');
          btn.classList.remove('tw-cart-add-btn--loading');
          if (btn.dataset.cartAddAriaLabel != null) {
            if (btn.dataset.cartAddAriaLabel) {
              btn.setAttribute('aria-label', btn.dataset.cartAddAriaLabel);
            } else {
              btn.removeAttribute('aria-label');
            }
            delete btn.dataset.cartAddAriaLabel;
          }
          if (btn.dataset.cartAddHtml != null) {
            btn.innerHTML = btn.dataset.cartAddHtml;
            delete btn.dataset.cartAddHtml;
          }
          btn.disabled = btn.dataset.cartAddWasDisabled === '1';
          delete btn.dataset.cartAddWasDisabled;
        }
      });
    }

    // Handle add to cart forms
    on(document, 'submit', function(e) {
      const form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        e.preventDefault();

        const addButtons = getAddButtonsForForm(form);
        setAddButtonsLoading(addButtons, true);

        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        const quantity = parseInt(data.quantity) || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: data.id, quantity: quantity })
        })
        .then(response => response.json())
        .then(() => {
          openDrawer({ fromAdd: true });
          return updateCart({ openUpsellPanel: !isMobileViewport() ? true : false });
        })
        .then(function () {
          requestAnimationFrame(function () {
            document.dispatchEvent(new CustomEvent('tw-cart:drawer-ready'));
          });
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          document.dispatchEvent(new CustomEvent('tw-cart:drawer-error'));
          alert('Error adding product to cart');
        })
        .finally(() => {
          setAddButtonsLoading(addButtons, false);
        });
      }
    });
    
    // Keep drawer/cart badge synced with external add-to-cart flows.
    // Some components dispatch `cart:updated` (without opening drawer),
    // others dispatch `cart:item-added` (should open drawer).
    on(document, 'cart:updated', function() {
      updateCart();
    });
    on(document, 'cart:item-added', function (e) {
      var token = e.detail && e.detail.token;
      openDrawer({ fromAdd: true });
      updateCart({ openUpsellPanel: !isMobileViewport() ? true : false })
        .then(function () {
          requestAnimationFrame(function () {
            document.dispatchEvent(new CustomEvent('tw-cart:drawer-ready', { detail: { token: token } }));
          });
        })
        .catch(function (err) {
          console.error('Cart update after add failed:', err);
          document.dispatchEvent(new CustomEvent('tw-cart:drawer-error', { detail: { token: token } }));
        });
    });
    
    // Update cart count on page load
    updateCartTotal();
    // Bind note and discount when drawer already has addons (Liquid-rendered)
    if (cartDrawer.querySelector('[data-cart-addons]')) {
      bindNoteAndDiscount();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-pdp-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.tw-pdp-buy-buttons__qty-input').forEach(function(qtyInput) {
      var form = qtyInput.closest('form');
      if (!form) return;
      var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var max = parseInt(qtyInput.getAttribute('max'), 10) || 99;
      var row = qtyInput.closest('.tw-pdp-buy-buttons__row');
      if (!row) return;
      row.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var n = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = Math.max(min, n - 1);
        });
      });
      row.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var n = parseInt(qtyInput.value, 10) || min;
          qtyInput.value = Math.min(max, n + 1);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-pdp-variant-picker"] && !Shopify.designMode) return;
  try {
    (function() {
    /* ── Reflejar opción seleccionada en el label "Color: X" / "Talla: X" ── */
    document.querySelectorAll('.tw-variant-picker').forEach(function(picker) {
      picker.addEventListener('change', function(e) {
        var input = e.target;
        if (!input || !input.classList || !input.classList.contains('tw-variant-option')) return;
        var pos = input.getAttribute('data-option-position');
        if (!pos) return;
        var label = picker.querySelector('[data-selected-value-for="' + pos + '"]');
        if (label) {
          var val = (input.tagName === 'SELECT')
            ? (input.options[input.selectedIndex] ? input.options[input.selectedIndex].text : input.value)
            : input.value;
          label.textContent = (val || '').trim();
        }
      });
    });

    /* ── Size guide modal ── */
    var openTriggers = document.querySelectorAll('[data-tw-size-guide-open]');
    if (!openTriggers.length) return;

    var lastFocused = null;

    function openModal(modal) {
      if (!modal) return;
      lastFocused = document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tw-size-guide-open');
      var closeBtn = modal.querySelector('.tw-size-guide-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tw-size-guide-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (e) {}
      }
    }

    openTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-tw-size-guide-target');
        if (!targetId) return;
        var modal = document.getElementById(targetId);
        if (modal) openModal(modal);
      });
    });

    document.querySelectorAll('.tw-size-guide-modal').forEach(function(modal) {
      modal.querySelectorAll('[data-tw-size-guide-close]').forEach(function(el) {
        el.addEventListener('click', function() { closeModal(modal); });
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.tw-size-guide-modal[aria-hidden="false"]').forEach(function(m) {
        closeModal(m);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-product-media"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      var slides = gallery.querySelectorAll('.tw-gallery__slide');
      var thumbs = gallery.querySelectorAll('.tw-gallery__thumb');
      var dots = gallery.querySelectorAll('.tw-gallery__dot');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var total = slides.length;
      if (total < 2) return;

      var current = 0;
      var animating = false;

      function goTo(index, direction) {
        if (animating || index === current || index < 0 || index >= total) return;
        animating = true;

        var oldSlide = slides[current];
        var newSlide = slides[index];

        var exitClass = direction === 'next' ? 'tw-gallery__slide--exit-left' : 'tw-gallery__slide--exit-right';
        var enterFrom = direction === 'next' ? 'tw-translate-x-full' : 'tw-gallery__slide--exit-left';

        newSlide.classList.remove('tw-translate-x-full', 'tw-opacity-0', 'tw-pointer-events-none', 'tw-gallery__slide--exit-left', 'tw-gallery__slide--exit-right');
        if (direction === 'next') {
          newSlide.style.transform = 'translateX(100%)';
        } else {
          newSlide.style.transform = 'translateX(-100%)';
        }
        newSlide.style.opacity = '0';

        void newSlide.offsetWidth;

        newSlide.style.transform = '';
        newSlide.style.opacity = '';
        newSlide.classList.add('tw-gallery__slide--active');
        newSlide.setAttribute('aria-hidden', 'false');

        oldSlide.classList.remove('tw-gallery__slide--active');
        oldSlide.classList.add(exitClass);
        oldSlide.setAttribute('aria-hidden', 'true');

        setTimeout(function() {
          oldSlide.classList.remove(exitClass);
          oldSlide.classList.add('tw-translate-x-full', 'tw-opacity-0', 'tw-pointer-events-none');
          animating = false;
        }, 320);

        thumbs.forEach(function(t, i) {
          var isActive = i === index;
          t.classList.toggle('tw-border-gray-900', isActive);
          t.classList.toggle('tw-border-transparent', !isActive);
          t.setAttribute('data-active', isActive ? 'true' : 'false');
          if (isActive) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });

        dots.forEach(function(d, i) {
          d.classList.toggle('tw-gallery__dot--active', i === index);
        });

        current = index;
      }
      
      gallery.goToSlide = function(index) {
        if (index === current || index < 0 || index >= total) return;
        goTo(index, index > current ? 'next' : 'prev');
      };

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current <= 0 ? total - 1 : current - 1, 'prev'); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current >= total - 1 ? 0 : current + 1, 'next'); });

      thumbs.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
          goTo(idx, idx > current ? 'next' : 'prev');
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
          goTo(idx, idx > current ? 'next' : 'prev');
        });
      });

      var thumbWrap = gallery.querySelector('.tw-gallery__thumbs-wrap');
      if (thumbWrap) {
        var thumbsContainer = thumbWrap.querySelector('.tw-gallery__thumbs');
        var btnUp = thumbWrap.querySelector('.tw-gallery__thumb-arrow--up');
        var btnDown = thumbWrap.querySelector('.tw-gallery__thumb-arrow--down');
        var btnLeft = thumbWrap.querySelector('.tw-gallery__thumb-arrow--left');
        var btnRight = thumbWrap.querySelector('.tw-gallery__thumb-arrow--right');

        var scrollAmount = 140; // Roughly 2 thumbnails

        if (btnUp) btnUp.addEventListener('click', function() { thumbsContainer.scrollBy({ top: -scrollAmount, behavior: 'smooth' }); });
        if (btnDown) btnDown.addEventListener('click', function() { thumbsContainer.scrollBy({ top: scrollAmount, behavior: 'smooth' }); });
        if (btnLeft) btnLeft.addEventListener('click', function() { thumbsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' }); });
        if (btnRight) btnRight.addEventListener('click', function() { thumbsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' }); });
      }


      var startX = 0;
      var deltaX = 0;
      var swiping = false;
      var viewport = gallery.querySelector('.tw-gallery__viewport');
      if (viewport) {
        viewport.addEventListener('touchstart', function(e) {
          startX = e.touches[0].clientX;
          swiping = true;
        }, { passive: true });
        viewport.addEventListener('touchmove', function(e) {
          if (!swiping) return;
          deltaX = e.touches[0].clientX - startX;
        }, { passive: true });
        viewport.addEventListener('touchend', function() {
          if (!swiping) return;
          swiping = false;
          if (Math.abs(deltaX) > 40) {
            if (deltaX < 0) goTo(current >= total - 1 ? 0 : current + 1, 'next');
            else goTo(current <= 0 ? total - 1 : current - 1, 'prev');
          }
          deltaX = 0;
        });
      }

      gallery.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') goTo(current <= 0 ? total - 1 : current - 1, 'prev');
        if (e.key === 'ArrowRight') goTo(current >= total - 1 ? 0 : current + 1, 'next');
      });

      /* ── Lightbox ── */
      var lightbox = gallery.querySelector('[data-lightbox]');
      if (!lightbox) return;

      var lbItems = lightbox.querySelectorAll('[data-lightbox-item]');
      var lbPrev = lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-lightbox-next]');
      var lbCounter = lightbox.querySelector('[data-lightbox-counter]');
      var lbTotal = lbItems.length;
      var lbCurrent = 0;

      function lbUpdateCounter() {
        if (lbCounter) lbCounter.textContent = (lbCurrent + 1) + ' / ' + lbTotal;
      }

      function lbShow(idx) {
        lbItems.forEach(function(item, i) {
          var img = item.querySelector('[data-lightbox-img]');
          if (img) {
            img.classList.remove('tw-lightbox__img--zoomed');
            img.style.transformOrigin = 'center center';
          }
          item.classList.toggle('tw-lightbox__item--active', i === idx);
        });
        lbCurrent = idx;
        lbUpdateCounter();
      }

      function lbOpen(idx) {
        lbShow(idx);
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function lbClose() {
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      var viewport = gallery.querySelector('.tw-gallery__viewport');
      if (viewport) {
        viewport.addEventListener('click', function(e) {
          if (e.target.closest('[data-gallery-prev]') || e.target.closest('[data-gallery-next]')) return;
          lbOpen(current);
        });
      }

      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function(btn) {
        btn.addEventListener('click', lbClose);
      });

      if (lbPrev) lbPrev.addEventListener('click', function() {
        lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
      });
      if (lbNext) lbNext.addEventListener('click', function() {
        lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
      });

      lbItems.forEach(function(item) {
        var img = item.querySelector('[data-lightbox-img]');
        if (!img) return;

        img.addEventListener('click', function(e) {
          e.stopPropagation();
          var isZoomed = img.classList.contains('tw-lightbox__img--zoomed');
          if (isZoomed) {
            img.classList.remove('tw-lightbox__img--zoomed');
            img.style.transformOrigin = 'center center';
          } else {
            var rect = img.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = x + '% ' + y + '%';
            img.classList.add('tw-lightbox__img--zoomed');
          }
        });

        img.addEventListener('mousemove', function(e) {
          if (!img.classList.contains('tw-lightbox__img--zoomed')) return;
          var rect = item.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
        });
      });

      var lbSwipeX = 0;
      var lbSwipeDx = 0;
      var lbSwiping = false;
      var lbStage = lightbox.querySelector('[data-lightbox-stage]');
      if (lbStage) {
        lbStage.addEventListener('touchstart', function(e) {
          lbSwipeX = e.touches[0].clientX;
          lbSwiping = true;
        }, { passive: true });
        lbStage.addEventListener('touchmove', function(e) {
          if (!lbSwiping) return;
          lbSwipeDx = e.touches[0].clientX - lbSwipeX;
        }, { passive: true });
        lbStage.addEventListener('touchend', function() {
          if (!lbSwiping) return;
          lbSwiping = false;
          if (Math.abs(lbSwipeDx) > 50) {
            if (lbSwipeDx < 0) lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
            else lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
          }
          lbSwipeDx = 0;
        });
      }

      document.addEventListener('keydown', function(e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowLeft') lbShow(lbCurrent <= 0 ? lbTotal - 1 : lbCurrent - 1);
        if (e.key === 'ArrowRight') lbShow(lbCurrent >= lbTotal - 1 ? 0 : lbCurrent + 1);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-search-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    var overlay = document.getElementById('tw-search-overlay');
    var popup = document.getElementById('tw-search-popup');
    var input = document.getElementById('tw-search-input');
    var loading = document.querySelector('[data-tw-search-loading]');
    var resultsBox = document.querySelector('[data-tw-search-results]');
    var keywordsBox = document.querySelector('[data-tw-search-keywords]');
    var popularBox = document.querySelector('[data-tw-search-popular]');
    var openBtns = document.querySelectorAll('[data-tw-open-search]');
    var closeBtn = document.querySelector('[data-tw-search-close]');

    var debounceTimer = null;
    var predictiveUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'search/suggest'
      : '/search/suggest';

    function open() {
      if (overlay) overlay.classList.add('is-open');
      if (popup) popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) { input.focus(); input.value = ''; }
      showDefaultContent();
    }

    function close() {
      if (overlay) overlay.classList.remove('is-open');
      if (popup) popup.classList.remove('is-open');
      document.body.style.overflow = '';
      if (input) input.value = '';
      showDefaultContent();
    }

    function showDefaultContent() {
      if (resultsBox) { resultsBox.style.display = 'none'; resultsBox.innerHTML = ''; }
      if (keywordsBox) keywordsBox.style.display = '';
      if (popularBox) popularBox.style.display = '';
    }

    function showResults(html) {
      if (keywordsBox) keywordsBox.style.display = 'none';
      if (popularBox) popularBox.style.display = 'none';
      if (resultsBox) { resultsBox.style.display = ''; resultsBox.innerHTML = html; }
    }

    function setLoading(on) {
      if (loading) loading.classList.toggle('is-loading', on);
    }

    function fetchPredictive(query) {
      if (!query || query.length < 2) {
        showDefaultContent();
        return;
      }

      setLoading(true);

      var url = predictiveUrl
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product,query,page,article,collection'
        + '&resources[limit]=5'
        + '&section_id=tw-search-predictive-grid';

      fetch(url)
        .then(function(r) { return r.text(); })
        .then(function(text) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(text, 'text/html');
          var sectionContent = doc.querySelector('#shopify-section-tw-search-predictive-grid');
          if (sectionContent) {
            showResults(sectionContent.innerHTML);
          }
          setLoading(false);
        })
        .catch(function() {
          setLoading(false);
        });
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); open(); });
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup && popup.classList.contains('is-open')) close();
    });

    if (input) {
      input.addEventListener('input', function() {
        var q = this.value.trim();
        clearTimeout(debounceTimer);
        if (q.length < 2) {
          showDefaultContent();
          setLoading(false);
          return;
        }
        debounceTimer = setTimeout(function() { fetchPredictive(q); }, 300);
      });
    }

    var kwPills = document.querySelectorAll('[data-tw-search-keyword]');
    kwPills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var kw = this.getAttribute('data-tw-search-keyword');
        if (input) input.value = kw;
        fetchPredictive(kw);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tw-size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function() {
    const modal = document.getElementById('tw-size-guide-modal');
    if (!modal) return;
    const body = modal.querySelector('.tw-size-guide-body');
    const overlay = modal.querySelector('.tw-size-guide-overlay');

    function open(contentId) {
      const source = contentId ? document.getElementById(contentId) : null;
      if (source) {
        const inner = source.querySelector('.tw-size-guide-content__inner');
        body.innerHTML = inner ? inner.innerHTML : source.innerHTML;
      } else {
        body.innerHTML = '';
      }
      modal.classList.remove('tw-hidden');
      modal.classList.add('tw-flex');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.add('tw-hidden');
      modal.classList.remove('tw-flex');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      const openBtn = e.target.closest('[data-tw-size-guide-open]');
      if (openBtn) {
        e.preventDefault();
        const contentId = openBtn.getAttribute('data-tw-size-guide-content');
        open(contentId);
      }
      if (e.target.closest('[data-tw-size-guide-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
